import * as Types from '../../../__generated__/types';

import { gql } from '@apollo/client';
import { UserBasicInfoFragmentDoc } from '../../../screens/communities/components/GroupMembersList/__generated__/user.fragment.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetInvitationsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type GetInvitationsQuery = { __typename?: 'Query', currentUser: { __typename?: 'User', id: string, username: string, friendshipRequestsSent: Array<{ __typename?: 'Invite', id: string, toUser: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, friendshipRequestsReceived: Array<{ __typename?: 'Invite', id: string, fromUser: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, superPalOf: Array<{ __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null, friendshipRequestsReceived: Array<{ __typename?: 'Invite', id: string, createdAt: number, fromUser: { __typename?: 'User', id: string, uuid: string, email?: string | null, username: string, photoUrl?: string | null, firstName?: string | null, lastName?: string | null } }>, addToOrganisationRequestsReceived: Array<{ __typename?: 'OrganisationImportMemberRequest', id: string, fromOrganisationMember: { __typename?: 'OrganisationMemberUser', id: string }, organisation: { __typename?: 'Organisation', id: string, name: string } }> }> } };


export const GetInvitationsDocument = gql`
    query GetInvitations {
  currentUser {
    id
    username
    friendshipRequestsSent {
      id
      toUser {
        ...UserBasicInfo
      }
    }
    friendshipRequestsReceived {
      id
      fromUser {
        ...UserBasicInfo
      }
    }
    superPalOf {
      ...UserBasicInfo
      friendshipRequestsReceived {
        id
        createdAt
        fromUser {
          ...UserBasicInfo
        }
      }
      addToOrganisationRequestsReceived {
        id
        fromOrganisationMember {
          id
        }
        organisation {
          id
          name
        }
      }
    }
  }
}
    ${UserBasicInfoFragmentDoc}`;

/**
 * __useGetInvitationsQuery__
 *
 * To run a query within a React component, call `useGetInvitationsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvitationsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvitationsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvitationsQuery(baseOptions?: Apollo.QueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
      }
export function useGetInvitationsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
// @ts-ignore
export function useGetInvitationsSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;
export function useGetInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>): Apollo.UseSuspenseQueryResult<GetInvitationsQuery | undefined, GetInvitationsQueryVariables>;
export function useGetInvitationsSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetInvitationsQuery, GetInvitationsQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetInvitationsQuery, GetInvitationsQueryVariables>(GetInvitationsDocument, options);
        }
export type GetInvitationsQueryHookResult = ReturnType<typeof useGetInvitationsQuery>;
export type GetInvitationsLazyQueryHookResult = ReturnType<typeof useGetInvitationsLazyQuery>;
export type GetInvitationsSuspenseQueryHookResult = ReturnType<typeof useGetInvitationsSuspenseQuery>;
export type GetInvitationsQueryResult = Apollo.QueryResult<GetInvitationsQuery, GetInvitationsQueryVariables>;